<template>
  <div class="uk-section">
    <div class="uk-container">
      <div class="max-w-md w-full space-y-8">
        <div v-if="success">
            <div class="uk-width-1-2 uk-width-1-3@m uk-margin-auto">
          <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
            <h2 class="uk-text-center">
              Revisa tu email
            </h2>
            <p class="uk-text-center">{{ successMessage }}</p>
            <p class="uk-text-center"><router-link :to="{ name: 'Login' }" class="uk-button uk-button-primary">Login</router-link></p>
          </div>
          </div>
        </div>
        <div v-else>
          <div class="uk-width-1-2 uk-width-1-3@m uk-margin-auto">
            <div class="uk-card uk-card-default uk-card-body uk-border-rounded">
              <h2
                class="uk-text-center"
              >
                Olvidaste tu contraseña?
              </h2>
              <p class="uk-text-center">
                No te preocupes, te ayudaremos a restablecerla.
              </p>

              <form class="mt-8 space-y-6" @submit.prevent="resetpassword">
                <input type="hidden" name="remember" value="true" />
                <div class="rounded-md shadow-sm -space-y-px">
                  <div class="uk-margin">
                    <label for="email-address" class="sr-only"
                      >Correo Electronico</label
                    >
                    <input
                      v-model="email"
                      id="email-address"
                      name="email"
                      type="email"
                      autocomplete="email"
                      required=""
                      class="uk-input"
                    />
                  </div>
                </div>
                <div>
                  <button type="submit" class="uk-button uk-button-primary">
                    Restablecer contraseña
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

export default {
  name: "Login",
  data() {
    return {
      email: null,
      success: false,
      successMessage: "",
    };
  },
  methods: {
    async resetpassword() {
      const email = this.email;
      const auth = getAuth();

      await sendPasswordResetEmail(auth, email)
        .then(() => {
          this.successMessage =
            "Se ha enviado un correo electronico a " + email;
          this.success = true;
          console.log("Password reset email sent!");
        })
        .catch((error) => {
          this.success = true;
          this.successMessage = error.message;
          console.log(error);
        });
    },
  },
  computed: {},
};
</script>
